<template>
  <div id="head" :class="{rollBg:isrollBg}">
    <div class="box">
      <div>
        <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/LOGO.png" alt="">
      </div>
      <ul>
        <li>
          <router-link to="/" class="padd hoverEffect" :class="{head_checked:activeIndex==1}">首页</router-link>
        </li>
        <li class="padd hoverEffect" :class="{head_checked:activeIndex==2}" @mouseenter="hovershow" @mouseleave="hovershow" style="position:relative">产品服务
          <ol v-show="ishover" class="productCenter pubShadow" :class="{rollBg1:isrollBg}">
            <router-link :class="{'hoverEffect':true,checked:item.checked}" :to="item.path" v-for="(item,index) of textArr" :key="index">{{item.text}}</router-link>
          </ol>
        </li>
        <li class="padd hoverEffect" :class="{head_checked:activeIndex==3}" @mouseenter.stop="hovershow1(true)" @mouseleave.stop="hovershow1(false)" style="position:relative">解决方案
          <ol v-show="ishover1" class="solution pubShadow" :class="{rollBg1:isrollBg}">
            <router-link :class="{'hoverEffect':true,checked:item.checked}" :to="item.path" v-for="(item,index) of textArr1" :key="index">{{item.text}}</router-link>
          </ol>
        </li>
        <li :class="{padd:true,hoverEffect:true,head_checked:activeIndex==4}" @mouseenter="hovershow2" @mouseleave="hovershow2" style="position:relative">行业终端
          <ol v-show="ishover2" class="solution pubShadow" :class="{rollBg1:isrollBg}">
            <router-link :class="{'hoverEffect':true,checked:item.checked}" :to="item.path" v-for="(item,index) of textArr2" :key="index">{{item.text}}</router-link>
          </ol>
        </li>
        <li>
          <router-link to="/about" class="padd hoverEffect" :class="{head_checked:activeIndex==5}">关于我们</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      activeIndex: 1,
      textArr: [
        { path: '/internetCard', text: '物联网卡', checked: false },
        { path: '/mozu', text: '通信模组', checked: false },
        { path: '/development', text: '开发板', checked: false }
      ],
      ishover: false,
      textArr1: [
        { path: '/quality', text: '水质(水文)监测系统', checked: false },
        { path: '/whiteAnt', text: '白蚁防治监测系统', checked: false },
        { path: '/cruiseWater', text: '巡水管理系统', checked: false },
        { path: '/dam', text: '大坝监测系统', checked: false },
        { path: '/irrigatedArea', text: '灌区信息化管理系统', checked: false },
        { path: '/property', text: '资产管理系统', checked: false },
        { path: '/cardSystem', text: '物联网卡管理系统', checked: false },
        { path: '/doorSystem', text: '智能无线门磁系统', checked: false }
      ],
      ishover1: false,
      textArr2: [
        { path: '/door', text: '智能无线门磁', checked: false },
        { path: '/DTU', text: '工业mini DTU', checked: false },
        { path: '/qualityMonitoring', text: '水质监测浮动站', checked: false },
        { path: '/antCondition', text: '地下型蚁情监测器', checked: false }
      ],
      ishover2: false,
      path: this.$route.fullPath,
      isrollBg: false
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    '$route': 'getPath'
  },
  mounted () {
    this.$router.push('/')
    this.$bus.$on('nameOfEvent', ($event) => {
      this.ishover1 = !this.ishover1
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getPath (now, old) {
      let oldI = 0
      let oldJ = 0
      if (old.name != null)      {
        let oldI = Number(old.meta.slice(0, 1))
        let oldJ = Number(old.meta.slice(2))
        let newI = Number(now.meta.slice(0, 1))
        let newJ = Number(now.meta.slice(2))
        this.checkfun(oldI, oldJ, newI, newJ)
      }
    },
    checkfun (oldI, oldJ, newI, newJ) {
      this.activeIndex = newI
      this.checkTab(oldI, oldJ, false)
      this.checkTab(newI, newJ, true)
    },
    checkTab (i, j, blo) {
      if (i === 2)      {
        this.$nextTick(() => {
          this.textArr[j - 1].checked = blo
        })
      } else if (i === 3)      {
        this.textArr1[j - 1].checked = blo
      } else if (i === 4)      {
        this.textArr2[j - 1].checked = blo
      }
    },
    hovershow () {
      this.ishover1 = false
      this.ishover = !this.ishover
    },
    hovershow1 (blo) {
      this.ishover1 = blo
    },
    hovershow2 () {
      this.ishover1 = false
      this.ishover2 = !this.ishover2
    },
    handleScroll () {
      this.scroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
      if (this.scroll > 0)      {
        this.isrollBg = true
      } else      {
        this.isrollBg = false
      }
    }
  },
  components: {},
};
</script>

<style scoped>
#head {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.12);
  z-index: 9999;
}
.box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}
ul {
  display: flex;
  height: 100%;
}
ul > li {
  margin: 0 6px;
  height: 50px;
  display: flex;
  align-items: center;
  z-index: 1;
}
.padd {
  display: flex;
  align-items: center;
  padding: 0 22px;
  height: 100%;
  color: white;
}
ul > li a {
  z-index: 20;
}
ul > li:nth-of-type(1) {
  margin-right: 5px;
}
ul > li:nth-of-type(1) a {
  padding: 0 15px;
}
ul > li:last-of-type {
  margin: 0 0 0 6px;
}
.hoverEffect:hover {
  color: #333333;
}
.checked {
  color: #333333;
}
.head_checked {
  color: #333333 !important;
  background-color: white;
  border-radius: 0 0 10px 10px;
}
.productCenter {
  width: 100%;
}
.productCenter a,
.solution a {
  font-size: 14px;
  line-height: 14px;
  padding: 10px 0 10px 22px;
  color: white;
}
.productCenter .checked,
.solution .checked {
  color: #333333 !important;
}
.solution {
  width: 165px;
}
.solution,
.productCenter {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50px;
  left: 0;
  border-radius: 10px;
  padding: 10px 0px 10px 0px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.24);
}
.rollBg {
  background: rgba(6, 86, 182, 0.8) !important;
}
.rollBg1 {
  background: rgba(85, 159, 247, 0.8) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue